export var verifiedValues = [
    { subtract: [1, 'w'], value: '1 weeks', name: '1 Week' },
    { subtract: [1, 'M'], value: '1 months', name: '1 Month' },
    { subtract: [3, 'M'], value: '3 months', name: '3 Months' },
    { subtract: [6, 'M'], value: '6 months', name: '6 Months' },
    { value: null, name: 'Any' }
];
